import { render, staticRenderFns } from "./AddBlockWifi.vue?vue&type=template&id=19e60d70&"
import script from "./AddBlockWifi.vue?vue&type=script&lang=js&"
export * from "./AddBlockWifi.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./AddBlockWifi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports